import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import SuccessModal from "../../common/SuccessModal/SuccessModal";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import SetPassword from "../SetPassword/SetPassword";
import VerifyOtp from "../VerifyOtp/VerifyOtp";
import passwordHidden from "../../../assets/images/Eye close.png";
import passwordVisible from "../../../assets/images/Eye open.png";
import "../../../assets/css/components/Login/Login.css";
import Cookies from "universal-cookie";

const Login = inject("loginStore", "sharedStore")(observer(class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      email: "",
      forgotEmail: "",
      otp: "",
      passwordShow: false,
      emailErr: "",
      passErr: "",
      scrolling: false,
      visibleModal: "",
      passwordSuccessResonse: "",
    };
    this.closeModal = this.closeModal.bind(this);
    this.switchModalVisibility = this.switchModalVisibility.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  static contextTypes = {
    router: PropTypes.object,
  };

  componentDidMount() {
    this.isLogin();
    window.addEventListener("scroll", this.windowScrolling);
  }

  isLogin() {
    this.props.sharedStore.showLoader();
    this.props.loginStore
      .isUserLoggedIn()
      .then((resp) => {
        this.props.sharedStore.hideLoader();
        if (resp && resp.status_code === 200) {
          this.props.sharedStore.setLoginDropDown(true);
          this.props.history.push("/profile");
        } else {
          this.props.sharedStore.setLoginDropDown(false);
        }
      })
      .catch((err) => {
        this.props.sharedStore.hideLoader();
      });
  }

  onInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit(e) {
    e.preventDefault();
    this.props.sharedStore.showLoader();
    const data = {
      email: this.state.email,
      password: this.state.password,
    };
    fetch("api/user/login/", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }).then((json) => {
      this.props.sharedStore.hideLoader();
      let data = json;
      if (data.error === false) {
        const cookies = new Cookies();
        cookies.set("auth", true, { domain: ".izenda.com" });
        cookies.set("auth", true, { path: "/" });
        this.props.sharedStore.clearInvoiceData();
        this.props.sharedStore.clearLicenseData();
        this.props.sharedStore.setCustomerSeriesType(data.customer_series);
        this.props.sharedStore.setUserRole(data.role);
        this.props.history.push("/profile");
      } else if (data.error === true) {
        this.setState({
          passErr: data.message,
        });
      } else {
        this.setState({ emailErr: "", passErr: "" });
        if (data.email) {
          this.setState({ emailErr: data.email });
        } else if (data.pass) {
          this.setState({ passErr: data.pass });
        } else {
          this.setState({ passErr: data.non_field_errors });
        }
      }
    });
  }

  windowScrolling = () => {
    if (window.scrollY > 100) {
      if (!this.state.scrolling) {
        this.setState({ scrolling: true });
      }
    } else {
      if (this.state.scrolling) {
        this.setState({ scrolling: false });
      }
    }
  };

  closeModal() {
    this.setState({
      visibleModal: "",
    });
  }

  switchModalVisibility(e, modalId, data = {}) {
    switch (modalId) {
      case 0:
        this.setState({
          visibleModal: modalId,
        });
        break;
      case 1:
        this.setState({
          visibleModal: modalId,
          forgotEmail: data.email,
        });
        break;
      case 2:
        this.setState({
          visibleModal: modalId,
          forgotEmail: data.email,
          otp: data.activation_key,
        });
        break;
      case 3:
        this.setState({
          visibleModal: modalId,
          passwordSuccessResonse: data.successMessage,
          forgotEmail: "",
          otp: "",
        });
        break;
      default:
    }
  }

  requestAccess = () => {
    this.props.history.push("/request-access");
  };

  render() {
    const heading = "Get Up and Running Fast!";
    const content1 =
      "Empower your organization to offer self-service analytics for end users with Izenda’s cutting-edge BI solution, the most modern stack on the market.";
    const content2 =
      "Fully embeddable into any application, Izenda enables development teams to focus on their core competency and reduces total cost of ownership while remaining invisible to your end users. Get the customization capabilities you’ve been looking for today.";

    return (
      <div className="login-wrapper">
        {/* Forgot Password modal */}

       
        <ForgotPassword
          modalVisibility={this.state.visibleModal === 0 ? true : false}
          closeModalHandler={this.closeModal}
          switchModalVisibility={this.switchModalVisibility}
          modalClass="iz-modal"
        />

        {/* Verify OTP modal */}
        <VerifyOtp
          modalVisibility={this.state.visibleModal === 1 ? true : false}
          closeModalHandler={this.closeModal}
          forgotEmail={this.state.forgotEmail}
          switchModalVisibility={this.switchModalVisibility}
          modalClass="iz-modal"
        />

        {/* Set New Password modal */}
        <SetPassword
          modalVisibility={this.state.visibleModal === 2 ? true : false}
          closeModalHandler={this.closeModal}
          forgotEmail={this.state.forgotEmail}
          otp={this.state.otp}
          switchModalVisibility={this.switchModalVisibility}
          modalClass="iz-modal"
        />
        

        {/* Modal with success message for password change */}
        <SuccessModal
          modalVisibility={this.state.visibleModal === 3 ? true : false}
          closeModalHandler={this.closeModal}
          messageContent={this.state.passwordSuccessResonse}
          modalLabel="Success Modal"
          modalClass="iz-modal"
        />
        <div>
          <div className="loginBackground">
            <div className="loginCenter">
              <ul className="flexLoginContainer">
                <li className="flexLoginItemLeft" style={{ display: "none" }}>
                  <div className="loginBoxParagraph">
                    <div className="loginBoxContent">
                      <p className="loginHeading">{heading}</p>
                      <p className="loginParagraph">{content1}</p>
                      <p className="loginParagraph">{content2}</p>
                    </div>
                  </div>
                </li>
                <li className="flexLoginItemRight">
                  <div className="loginBoxContent">
                    <div className="loginDeveloperBox">
                      <div className="loginDeveloperHeading">
                        <h3 className="loginDeveloperText">CUSTOMER PORTAL</h3>
                      </div>
                      <form onSubmit={this.handleSubmit} autoComplete="off">
                        <div className="loginEmailForm">
                          <input
                            id="Email"
                            className="loginEmailInput"
                            name="email"
                            autoComplete="off"
                            onChange={(e) => this.onInputChange(e)}
                            placeholder={"Enter Your Email"}
                            value={this.state.email}
                            type="email"
                          />
                          <p className="text-danger text-sm">
                            {this.state.emailErr}
                          </p>
                        </div>
                        <div className="loginPasswordBox">
                          <div className="loginPasswordForm">
                            <input
                              type={
                                this.state.passwordShow ? "text" : "password"
                              }
                              placeholder={"Enter Your Password"}
                              value={this.state.password}
                              onChange={(e) => this.onInputChange(e)}
                              className="loginPasswordInput"
                              name="password"
                              autoComplete="off"
                              required
                            />
                            <a
                              className="passwordEye"
                              onClick={() =>
                                this.setState({
                                  passwordShow: !this.state.passwordShow,
                                })
                              }
                            >
                              <img
                                alt="eye"
                                src={
                                  this.state.passwordShow
                                    ? passwordVisible
                                    : passwordHidden
                                }
                              />
                            </a>
                          </div>
                          <p className="text-danger pull-left">
                            {this.state.passErr}
                          </p>
                          <p
                            className="forgotPassword"
                            onClick={(e) => this.switchModalVisibility(e, 0)}
                          >
                            Forgot your password?
                          </p>
                        </div>
                        <div className="loginButtonContainer">
                          <button type="submit" className="loginButton">
                            Login
                          </button>
                        </div>
                      </form>
                    </div>
                    <div className="clear clearfix">
                      <div className="text-center">
                        <span className="getStartedLinkText">
                          Don't have an account?
                        </span>
                        <a
                          className="getStartedLink"
                          onClick={() => this.requestAccess()}
                        >
                          Request access
                        </a>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}));

export default Login;



// WEBPACK FOOTER //
// ./src/components/Authentication/Login/Login.jsx